import { ModulePackFE_FHIRQueryDB } from './_entity/fhir-query/module-pack.js';
import { ModulePackFE_FHIRResourceSubtypeDB } from './_entity/fhir-resource-subtype/module-pack.js';
import { ModulePackFE_FHIRResourceParamValueDB } from './_entity/fhir-resource-param-value/module-pack.js';
import { ModulePackFE_FHIRResourceDB } from './_entity/fhir-resource/module-pack.js';
import { ModulePackFE_FHIRResourceParamDB } from './_entity/fhir-resource-param/module-pack.js';
export const ModulePackFE_FHIR = [
    ...ModulePackFE_FHIRQueryDB,
    ...ModulePackFE_FHIRResourceDB,
    ...ModulePackFE_FHIRResourceSubtypeDB,
    ...ModulePackFE_FHIRResourceParamDB,
    ...ModulePackFE_FHIRResourceParamValueDB,
];
//# sourceMappingURL=module-pack.js.map